import { onEvent } from '../util/domutils'; // eslint-disable-line import/named

const easeInOutQuad = (currentTime, start, offset, duration) => {
  let newTime = currentTime / (duration / 2);
  if (newTime < 1) {
    return offset / 2 * newTime * newTime + start;
  }

  newTime--;
  return -offset / 2 * (newTime * (newTime - 2) - 1) + start;
};

const scrollElementHorizontal = (element, offset, duration) => {
  const start = element.scrollLeft;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, offset, duration);
    element.scrollLeft = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
};

const carousel = document.querySelector('.carousel-container');

if (carousel) {
  const tile = carousel.querySelector('.product-detail__tile-row__item');
  const tileWidth = tile.getBoundingClientRect().width;

  onEvent(document, 'click', '.carousel-control', (e) => {
    e.preventDefault();

    if (e.delegateTarget.dataset.controls === 'prev') {
      scrollElementHorizontal(carousel, tileWidth * -1, 300);
    } else if (e.delegateTarget.dataset.controls === 'next') {
      scrollElementHorizontal(carousel, tileWidth, 300);
    }
  });
}
